import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import moment from "moment";

const DrySeasonFertilizerReprot = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/researchProgramMIS");
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getCropCutData } = useHttp();

  const fillCropCutData = async (
    employeeId,
    regionId,
    farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/drySeasonFertilizerTrialReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getCropCutData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        if (getType == "Excel") {
          console.log("reportdata", data);
          // const handleDownload = async () => {
          //   const blob = await data.blob();
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.download = 'downloaded-file.csv'; // Set the file name here
          //   link.click();
          // }
        } else {
          console.log("reportdata", data);
          setData(data);
        }
      }
    );
  };

  const excelDownload = async (
    employeeId,
    regionId,
    farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/drySeasonFertilizerTrialReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "FertiliserTrial(A).xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fillCropCutData(0, 0, "");
  }, [getCropCutData]);

  const customHeaders = [
    "Doc No",
    "Date",
    "Season Name",
    "Crop Name",
    "Variety Name",
    "Executive Name",
    "NPK Fertilizer",
    "Nitrogen Fertilizer",
    "Rep",
    "Plant Height 4WAS(cm)",
    "Plant Height 6WAS(cm)",
    "Plant Height 8WAS(cm)",
    "Plant Height 10WAS(cm)",
    "Plant Height 12WAS(cm)",
    "Stem Girth 4WAS(mm)",
    "Stem Girth 6WAS(mm)",
    "Stem Girth 8WAS(mm)",
    "Stem Girth 10WAS(mm)",
    "Stem Girth 12WAS(mm)",
    "Num Leaves 4WAS",
    "Num Leaves 6WAS",
    "Num Leaves 8WAS",
    "Num Leaves 10WAS",
    "Num Leaves 12WAS",
    "Dry Matter 4WAS(gm)",
    "Dry Matter 6WAS(gm)",
    "Dry Matter 8WAS(gm)",
    "Dry Matter 10WAS(gm)",
    "Dry Matter 12WAS(gm)",
    "Num Plants Plot",
    "Num Cobs Plant",
    "Cob Length",
    "Mean CobWt",
    "Shelling%",
    "Grain 100Wt",
    "Grain Yield",
    "Stover Yield",
    "Moisture Content",
    "Days To 50%Anthesis",
    "Days To 50%Silking",
    "Dry Matter Weight",
    "Newweightat13%mc",
    "Yield Mt/Ha"
  ];

  const fieldsToExport = [
    "docNo",
    "drySeasonFertilizerTrialDate",
    "seasonName",
    "cropName",
    "varietyName",
    "executiveName",
    "npkProductName",
    "ureaProductName",
    "rep",
    "plantHeight4WS",
    "plantHeight6Was",
    "plantHeight8Was",
    "plantHeight10Was",
    "plantHeight12Was",
    "stemGirth4Was",
    "stemGirth6Was",
    "stemGirth8Was",
    "stemGirth10Was",
    "stemGirth12Was",
    "numLeaves4Was",
    "numLeaves6Was",
    "numLeaves8Was",
    "numLeaves10Was",
    "numLeaves12Was",
    "dryMatter4Was",
    "dryMatter6Was",
    "dryMatter8Was",
    "dryMatter10Was",
    "dryMatter12Was",
    "numPlantsPlot",
    "numCobsPlant",
    "cobLength",
    "meanCobWt",
    "shelling",
    "grain100Wt",
    "grainYield",
    "stoverYield",
    "moistureContent",
    "daysTo50Anthesis",
    "daysTo50Silking",
    "dryMatterweight",
    "newweightat13mc",
    "yieldMtPerHa",
  ];

  const handleExportExcel = () => {
    const filename = "Fertiliser Trial (A).xlsx";

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");
      return {
        ...item,
        latitude,
        longitude,
      };
    });

    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Fertiliser Trial(A)</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row align-items-end">
              {/* Procurement Officer */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="executive_officer">Agronomy Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      const userid =
                        e.target.value !== "--Select--" ? e.target.value : 0;
                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Apply Date Filter Dropdown */}
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="date_filter">Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {/* From and To Dates (conditional) */}
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        id="from_date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        id="to_date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit Button */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillCropCutData(employeeId, regionId, null);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>

            <h5>Please select the parameters to get the desired result</h5>
            <hr />
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>

              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, regionId, farmerNumber, "Excel");
                }}
                disabled={loading}
              > */}
              {/* {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )} */}
              {/* </button> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Doc No</th>
                          <th>Date</th>
                          <th>Season Name</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>
                          <th>Executive Name</th>
                          <th>NPK Fertiliser</th>
                          <th>Nitrogen Fertiliser</th>
                          <th>Rep</th>
                          <th>PlantHeight_4WAS</th>
                          <th>PlantHeight_6WAS</th>
                          <th>PlantHeight_8WAS</th>
                          <th>PlantHeight_10WAS</th>
                          <th>PlantHeight_12WAS</th>
                          <th>StemGirth_4WAS</th>
                          <th>StemGirth_6WAS</th>
                          <th>StemGirth_8WAS</th>
                          <th>StemGirth_10WAS</th>
                          <th>StemGirth_12WAS</th>
                          <th>NumLeaves_4WAS</th>
                          <th>NumLeaves_6WAS</th>
                          <th>NumLeaves_8WAS</th>
                          <th>NumLeaves_10WAS</th>
                          <th>NumLeaves_12WAS</th>
                          <th>DryMatter_4WAS</th>
                          <th>DryMatter_6WAS</th>
                          <th>DryMatter_8WAS</th>
                          <th>DryMatter_10WAS</th>
                          <th>DryMatter_12WAS</th>
                          <th>NumPlantsPlot</th>
                          <th>NumCobsPlant</th>
                          <th>CobLength</th>
                          <th>MeanCobWt</th>
                          <th>Shelling%</th>
                          <th>Grain100Wt</th>
                          <th>GrainYield</th>
                          <th>StoverYield</th>
                          <th>MoistureContent</th>
                          <th>DaysTo50%Anthesis</th>
                          <th>DaysTo50%Silking</th>
                          <th>Drymatterweight</th>
                          <th>Grain Yield 13%MC</th>
                          <th>Yield(mt/ha)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              {/* <td>{i + 1}</td> */}
                              <td>{itm.docNo  }</td>
                              <td>
                                {itm.drySeasonFertilizerTrialDate  }
                              </td>
                                <td>{itm.seasonName  }</td>
                              <td>{itm.cropName  }</td>
                              <td>{itm.varietyName  }</td>
                              <td>{itm.executiveName  }</td>
                              <td>{itm.npkProductName  }</td>
                              <td>{itm.ureaProductName  }</td>
                              <td>{itm.rep  }</td>
                              <td>{itm.plantHeight4WS  }</td>
                              <td>{itm.plantHeight6Was  }</td>
                              <td>{itm.plantHeight8Was  }</td>
                              <td>{itm.plantHeight10Was  }</td>
                              <td>{itm.plantHeight12Was  }</td>
                              <td>{itm.stemGirth4Was  }</td>
                              <td>{itm.stemGirth6Was  }</td>
                              <td>{itm.stemGirth8Was  }</td>
                              <td>{itm.stemGirth10Was  }</td>
                              <td>{itm.stemGirth12Was  }</td>
                              <td>{itm.numLeaves4Was  }</td>
                              <td>{itm.numLeaves6Was  }</td>
                              <td>{itm.numLeaves8Was  }</td>
                              <td>{itm.numLeaves10Was  }</td>
                              <td>{itm.numLeaves12Was  }</td>
                              <td>{itm.dryMatter4Was  }</td>
                              <td>{itm.dryMatter6Was  }</td>
                              <td>{itm.dryMatter8Was  }</td>
                              <td>{itm.dryMatter10Was  }</td>
                              <td>{itm.dryMatter12Was  }</td>
                              <td>{itm.numPlantsPlot  }</td>
                              <td>{itm.numCobsPlant  }</td>
                              <td>{itm.cobLength  }</td>
                              <td>{itm.meanCobWt  }</td>
                              <td>{itm.shelling  }</td>
                              <td>{itm.grain100Wt  }</td>
                              <td>{itm.grainYield  }</td>
                              <td>{itm.stoverYield  }</td>
                              <td>{itm.moistureContent  }</td>
                              <td>{itm.daysTo50Anthesis  }</td>
                              <td>{itm.daysTo50Silking  }</td>
                              <td>{itm.dryMatterweight }</td>
                              <td>{itm.newweightat13mc }</td>
                              <td>{itm.yieldMtPerHa }</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DrySeasonFertilizerReprot;
